import styled from "styled-components";

export const PortfolioOverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.ui.background.raised};
  padding: 24px;
  position: relative;
`;

export const TopSectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const TopSectionRightContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TopSectionLeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
`;

export const PerformanceDataContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const GrowthContainer = styled.div`
  display: flex;
  align-items: center;
  & > div {
    display: flex;
    align-items: center;
  }
`;

export const TitleWithIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TooltipWrapper = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  transition: all 0.2s ease-in-out;
  flex-shrink: 0;

  &:hover {
    background-color: ${({ theme }) => theme.colors.ui.background.page};
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;
